import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { messageService } from "../../../services";

function FanHomeMessagerieWrapper() {
  // const location = useLocation();
  // const dispatch = useDispatch<AppDispatch>();
  const [totalNotReadMessages, setTotalNotReadMessages] = useState<number | null>(null);
  // const [rtmpNavgation, setRtmpNavigation] = useState<string>("");
  // const redirectUrl = localStorage.getItem("redirectToEvent");
  // const searchParams = new URLSearchParams(location.search);
  // const isRtmpLive = localStorage.getItem("redirectToEvent") !== null;
  // const [isRtmpLiveLoading, setIsRtmpLiveLoading] = useState<boolean>(false);

  useEffect(() => {
    // TODO: enable this code for the upcoming event
    // const creatorCode = searchParams.get("code");
    // if (creatorCode && localStorage.getItem("creatorCode") !== creatorCode) {
    //   localStorage.setItem("creatorCode", creatorCode);
    // }
    // if (redirectUrl) {
    //   fetchRtmpLive(redirectUrl);
    // } else {
    fetchUnreadMessages();
    // }
  }, []);

  // const fetchRtmpLive = async (redirectUrl: string) => {
  //   setIsRtmpLiveLoading(true);
  //   try {
  //     const live = await liveService.getRtmpLive();
  //     dispatch(setRTMPStream(live));
  //     if (live) {
  //       const redirectRtmpUrl = live.isPaymentVerified ? (live.isStreaming ? `/fan/live/${live._id}` : "/fan/ifc2") : "/".concat(redirectUrl);
  //       setTotalNotReadMessages(0);
  //       setRtmpNavigation(redirectRtmpUrl);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   } finally {
  //     setIsRtmpLiveLoading(false);
  //   }
  // };

  const fetchUnreadMessages = async () => {
    try {
      const total = await messageService.getTotalNotReadMessages();
      if (total && total !== "") {
        setTotalNotReadMessages(parseInt(total, 10));
      } else {
        setTotalNotReadMessages(0);
      }
    } catch (error) {
      console.error(error);
      setTotalNotReadMessages(0);
    }
  };

  // if (isRtmpLiveLoading) {
  //   return <Spin spinning={isRtmpLiveLoading} style={{ height: "100%", width: "100%" }} indicator={<SpinnerComponent />} />;
  // }

  // if (rtmpNavgation) {
  //   localStorage.removeItem("redirectToEvent");
  //   return <Navigate to={rtmpNavgation} replace />;
  // } else if (location.pathname === "/ifc2" && !redirectUrl) {
  //   fetchRtmpLive("fan/ifc2");
  //   return <Navigate to={"/fan/ifc2"} replace />;
  // }

  // if (!isRtmpLive && location.pathname !== "/ifc2") {
  //   return <Navigate to="/fan/home" replace />;
  // }

  if (totalNotReadMessages === null) {
    return null;
  }

  if (totalNotReadMessages && totalNotReadMessages > 0) {
    return <Navigate to="/fan/message" replace />;
  } else {
    return <Navigate to="/fan/home" replace />;
  }
}

export default FanHomeMessagerieWrapper;
